module.exports = __webpack_public_path__ + "img/foto-estagio-5.30aeb097.png";